module.exports = __webpack_public_path__ + "img/kj5.3257962c.png";